<div class="d-flex flex-wrap justify-content-between align-items-center mb-4">
  <div class="d-flex align-items-center gap-3">
    <div>
      <h5 class="mb-1 fw-bold">Warehouses</h5>
      <span class="sub-text">Manage warehouses and plant heads</span>
    </div>
  </div>
  @if (currentUser?.role === UserRole.ADMIN) {
    <button class="btn btn-primary d-flex align-items-center gap-2" (click)="openAddWarehouseModal()">
      <i class="bi bi-plus-lg"></i>
      Add Warehouse
    </button>
  }
</div>

<div class="card border-0 shadow-none">
  <div class="card-body p-0">
    @if (isProductionManagersDataLoading) {
      <app-loading-spinner></app-loading-spinner>
    } @else {
      @if (wareHouses && wareHouses.length === 0) {
        <app-info-alert>{{ NO_WAREHOUSES_ALERT_MSG }}</app-info-alert>
      } @else {
        <div class="table-responsive">
          <app-table
            [data]="wareHouses"
            [columns]="columns"
            [actions]="actions"
            (onEdit)="openUpdateWarehouseModal($event)"
            (onDelete)="onDeleteWarehouse($event)"></app-table>
        </div>
      }
    }
  </div>
</div>

<ng-template #updateWarehouseContent let-modal>
  <div class="modal-content border-0 shadow-lg">
    <div class="modal-header">
      <h5 class="modal-title">Update Warehouse</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body p-4">
      <div class="mb-3">
        <label for="editWarehouseName" class="form-label small fw-bold text-muted text-uppercase">Warehouse Name</label>
        <input
          type="text"
          id="editWarehouseName"
          class="form-control shadow-none"
          [(ngModel)]="editWarehouseName"
          placeholder="Enter warehouse name" />
      </div>

      <div class="mb-3">
        <label for="editWarehouseAddress" class="form-label small fw-bold text-muted text-uppercase">Address</label>
        <textarea
          id="editWarehouseAddress"
          class="form-control shadow-none"
          [(ngModel)]="editWarehouseAddress"
          rows="2"
          placeholder="Enter warehouse address"></textarea>
      </div>

      <div class="mb-2">
        <label
          for="productionManagerSelect"
          class="form-label small fw-bold text-muted text-uppercase"
          style="font-size: 0.65rem; letter-spacing: 0.05em">
          Plant Head
        </label>
        <ng-select
          [items]="productionManagers"
          [(ngModel)]="selectedProductionManagerId"
          bindValue="id"
          bindLabel="full_name"
          [placeholder]="currentWarehouse?.plant_head?.full_name ? 'Remove / Keep current' : 'Not assigned'"
          [clearable]="true"
          [searchable]="true" />
      </div>
    </div>

    <div class="modal-footer p-4 pt-0 border-0">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!editWarehouseName || isUpdatingWarehouse"
        (click)="onUpdateWarehouse()">
        @if (isUpdatingWarehouse) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Updating...
        } @else {
          Update Warehouse
        }
      </button>
    </div>
  </div>
</ng-template>

<ng-template #addWarehouseContent let-modal>
  <div class="modal-content border-0 shadow-lg">
    <div class="modal-header">
      <h5 class="modal-title">Add Warehouse</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
    </div>

    <div class="modal-body p-4">
      <div class="mb-3">
        <label for="warehouseName" class="form-label small fw-bold text-muted text-uppercase">Warehouse Name</label>
        <input
          type="text"
          id="warehouseName"
          class="form-control shadow-none"
          [(ngModel)]="newWarehouseName"
          placeholder="Enter warehouse name" />
      </div>

      <div class="mb-3">
        <label for="warehouseAddress" class="form-label small fw-bold text-muted text-uppercase">Address</label>
        <textarea
          id="warehouseAddress"
          class="form-control shadow-none"
          [(ngModel)]="newWarehouseAddress"
          rows="2"
          placeholder="Enter warehouse address"></textarea>
      </div>
    </div>

    <div class="modal-footer p-2 border-0">
      <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
      <button
        type="button"
        class="btn btn-primary"
        [disabled]="!newWarehouseName || isAddingWarehouse"
        (click)="onAddWarehouse()">
        @if (isAddingWarehouse) {
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
          Adding...
        } @else {
          Add Warehouse
        }
      </button>
    </div>
  </div>
</ng-template>
